import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import ProtectedRoute from "./components/ProtectedRoute";
import AppLayout from "./components/AppLayout";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import OrdersPage from "./pages/OrdersPage";
import CollectionsPage from "./pages/CollectionsPage";
import GPSPage from "./pages/GPSPage";
import DailyReportPage from "./pages/DailyReportPage";
import TargetsPage from "./pages/TargetsPage";
import CustomersPage from "./pages/CustomersPage";
import ProductsPage from "./pages/ProductsPage";
import PriceListsPage from "./pages/PriceListsPage";
import TeamPerformancePage from "./pages/TeamPerformancePage";
import FarmersPage from "./pages/FarmersPage";
import UsersPage from "./pages/UsersPage";
import LeadsPage from "./pages/LeadsPage";
import DispatchesPage from "./pages/DispatchesPage";
import BRUpdatesPage from "./pages/BRUpdatesPage";
import FarmerMeetingsPage from "./pages/FarmerMeetingsPage";
import TodosPage from "./pages/TodosPage";
import NotificationsPage from "./pages/NotificationsPage";
import ReportsPage from "./pages/ReportsPage";
import MyExpensesPage from "./pages/MyExpensesPage";
import ExpenseApprovalsPage from "./pages/ExpenseApprovalsPage";
import DemonstrationsPage from "./pages/DemonstrationsPage";
import LeavesPage from "./pages/LeavesPage";
import AttendancePage from "./pages/AttendancePage";
import HolidaysPage from "./pages/HolidaysPage";
import TeamMemberDetailPage from "./pages/TeamMemberDetailPage";
import TeamDailyReportPage from "./pages/TeamDailyReportPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route element={<ProtectedRoute />}>
              <Route element={<AppLayout />}>
                <Route path="/" element={<Dashboard />} />
                <Route path="/orders" element={<OrdersPage />} />
                <Route path="/collections" element={<CollectionsPage />} />
                <Route path="/gps" element={<GPSPage />} />
                <Route path="/daily-report" element={<DailyReportPage />} />
                <Route path="/targets" element={<TargetsPage />} />
                <Route path="/leads" element={<LeadsPage />} />
                <Route path="/dispatches" element={<DispatchesPage />} />
                <Route path="/br-updates" element={<BRUpdatesPage />} />
                <Route path="/farmer-meetings" element={<FarmerMeetingsPage />} />
                <Route path="/todos" element={<TodosPage />} />
                <Route path="/notifications" element={<NotificationsPage />} />
                <Route path="/expenses/mine" element={<MyExpensesPage />} />
                <Route path="/demonstrations" element={<DemonstrationsPage />} />
                <Route path="/leaves" element={<LeavesPage />} />
                <Route path="/attendance" element={<AttendancePage />} />
                <Route path="/holidays" element={<HolidaysPage />} />
              </Route>
            </Route>
            <Route element={<ProtectedRoute roles={["admin", "director", "manager", "rm_and_above", "sales_manager"]} />}>
              <Route element={<AppLayout />}>
                <Route path="/team-performance" element={<TeamPerformancePage />} />
                <Route path="/reviews/daily-report" element={<TeamDailyReportPage />} />
                <Route path="/team/:userId" element={<TeamMemberDetailPage />} />
              </Route>
            </Route>
            <Route element={<ProtectedRoute roles={["admin", "director", "manager", "rm_and_above", "sales_manager", "hr"]} />}>
              <Route element={<AppLayout />}>
                <Route path="/expenses/approvals" element={<ExpenseApprovalsPage />} />
              </Route>
            </Route>
            <Route element={<ProtectedRoute roles={["admin", "manager", "director"]} />}>
              <Route element={<AppLayout />}>
                <Route path="/customers" element={<CustomersPage />} />
                <Route path="/products" element={<ProductsPage />} />
                <Route path="/price-lists" element={<PriceListsPage />} />
                <Route path="/farmers" element={<FarmersPage />} />
              </Route>
            </Route>
            <Route element={<ProtectedRoute roles={["admin", "manager", "director", "rm_and_above", "sales_manager"]} />}>
              <Route element={<AppLayout />}>
                <Route path="/reports" element={<ReportsPage />} />
              </Route>
            </Route>
            <Route element={<ProtectedRoute roles={["admin", "director"]} />}>
              <Route element={<AppLayout />}>
                <Route path="/users" element={<UsersPage />} />
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
